import store from './store';

export default function userStore(data) {
	if (typeof data === 'string') {
		return store(data);
	}

	data.local_token = Date.now() + 1000 * 60 * 60 * 24 * 14; // 14 days

	store(data);
}
